import  OIDC  from "./OIDC";
import  Auth  from "./AuthManager";

export default OIDC;
export { Auth };